import { Box, Grid, Typography, useTheme } from '@mui/material';
import React from 'react';
import {
  EntityName,
  EventType,
  SectionName,
} from 'src/utils/analytics/constants';
import { useImpressionEvent } from 'src/utils/analytics/hooks';
import { JumpPageSectionProps } from '../jump-page-body';

const companyLogos = [
  {
    id: 'chase',
    name: 'Chase',
    order: 1,
    imgUrl:
      'https://www.nerdwallet.com/cdn/performance-marketing-client/company-logos/chase.png',
  },
  {
    id: 'capitalOne',
    name: 'Capital One',
    order: 2,
    imgUrl:
      'https://www.nerdwallet.com/cdn/performance-marketing-client/company-logos/capital-one.png',
  },
  {
    id: 'americanExpress',
    name: 'American Express',
    order: 3,
    imgUrl:
      'https://www.nerdwallet.com/cdn/performance-marketing-client/company-logos/american-express.png',
  },
  {
    id: 'bankOfAmerica',
    name: 'Bank of America',
    order: 4,
    imgUrl:
      'https://www.nerdwallet.com/cdn/performance-marketing-client/company-logos/bank-of-america.png',
  },
  {
    id: 'citi',
    name: 'Citi',
    order: 5,
    imgUrl:
      'https://www.nerdwallet.com/cdn/performance-marketing-client/company-logos/citibank.png',
  },
  {
    id: 'wellsFargo',
    name: 'Wells Fargo',
    order: 6,
    imgUrl:
      'https://www.nerdwallet.com/cdn/performance-marketing-client/company-logos/wells-fargo.png',
  },
];

const ShowCaseSection: React.FC<JumpPageSectionProps> = ({
  analytics: { navigationId },
}) => {
  const theme = useTheme();

  const { ref } = useImpressionEvent({
    eventType: EventType.ElementImpression,
    navigationId,
    payload: {
      entity_name: EntityName.JumpCCBrands,
      section_name: SectionName.JumpCCBrands,
      section_position: 4,
    },
  });
  return (
    <Box
      ref={ref}
      display="flex"
      justifyContent="center"
      flexDirection="column"
      alignItems="center"
      paddingY={4}
    >
      <Typography textAlign="center" variant="textLargeBold" component="h2">
        Some of Our Partners
      </Typography>
      <Box
        marginTop={3.5}
        maxWidth="90%"
        marginLeft={3}
        sx={{
          [theme.breakpoints.down('md')]: {
            marginTop: 5,
            maxWidth: '100%',
          },
        }}
      >
        <Grid
          columnSpacing={{ xs: 3, md: 3 }}
          rowSpacing={{ xs: 4, md: 3 }}
          columns={{ xs: 2, md: 6 }}
          alignItems="center"
          justifyContent="center"
          display="flex"
          container
        >
          {companyLogos.map((logo) => (
            <Grid
              item
              key={logo.id}
              display="flex"
              maxWidth="12.5rem"
              alignItems="center"
              justifyContent="center"
              order={logo.order}
              sx={{
                [theme.breakpoints.down('sm')]: {
                  marginBottom: 3.5,
                  maxWidth: '10rem',
                },
              }}
              xs={1}
              md={1}
            >
              {/* eslint-disable-next-line @next/next/no-img-element */}
              <img
                src={logo.imgUrl}
                alt={logo.name}
                style={{ maxHeight: '100%', maxWidth: '100%' }}
              />
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default ShowCaseSection;
